// React bootstrap table next =>

import React, {useMemo, useRef} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {Button, Card} from 'react-bootstrap';
import paginationFactory, {PaginationProvider} from "react-bootstrap-table2-paginator";
import {sizePerPageList, defaultSorted, columns} from "./ui.helpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import {Pagination} from "../../../../_metronic/_partials/controls";
import {useLinksUIContext} from "../../../contexts/LinksUIContext";
import {Portal} from "@material-ui/core";

export function LinksTable(props) {
  const context = useLinksUIContext();
  const bottomAreaRef = useRef(null);
  const {totalCount, linkList, listLoading} = props;

  const {
    queryParams,
    setQueryParams,
    goToCreateLink,
    onClick,
  } = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
    goToCreateLink: context.goToCreateLink,
    onClick: (_, row) => context.openLinkDetailDialog(row.saleNo),
  }), [context]);

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  return (
    <Card>
      <Card.Body>
        {bottomAreaRef.current && (
          <Portal container={bottomAreaRef.current}>
            <Button
              size="sm"
              onClick={goToCreateLink}
            >+ 판매등록
            </Button>

          </Portal>
        )}

        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({paginationProps, paginationTableProps}) => (
            <Pagination isLoading={listLoading} paginationProps={paginationProps} bottomAreaRef={bottomAreaRef}>
              <BootstrapTable
                remote
                hover
                bootstrap4
                keyField="no"
                bordered={false}
                columns={columns}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden table-responsible"
                data={linkList === null ? [] : linkList}
                defaultSorted={defaultSorted}
                noDataIndication={<NoRecordsFoundMessage entities={linkList}/>}
                onTableChange={getHandlerTableChange(setQueryParams)}
                rowEvents={{onClick}}
                {...paginationTableProps}
              />
            </Pagination>
          )}
        </PaginationProvider>
      </Card.Body>
    </Card>
  );
}
